import { gql } from 'apollo-boost'

const HTML_MENU_SCRAPING_JOB = gql`
  query htmlMenuScrapingJob($id: ID!) {
    htmlMenuScrapingJob(id: $id) {
      id
      createdDate
      existingMenuTitleCount
      scrapedMenuTitleCount
      createdMenuTitleCount
      significantlyUpdatedMenuTitleCount
      updatedMenuTitleCount
      deletedMenuTitleCount
      restoredMenuTitleCount
      createdMenuTitles
      updatedMenuTitles
      deletedMenuTitles
      restoredMenuTitles
      existingDishCount
      scrapedDishCount
      createdDishCount
      significantlyUpdatedDishCount
      updatedDishCount
      deletedDishCount
      restoredDishCount
      createdDishes
      updatedDishes
      deletedDishes
      restoredDishes
      completedDate
      htmlMenuScrapingResponse {
        id
        data
      }
    }
  }
`

export default HTML_MENU_SCRAPING_JOB
